import { useTranslation } from "react-i18next";

import { PlaceDesignData } from "../../models";

import PlaceRow from "./PlaceRow";
import { Table, TableHead, TableHeadCell, TableHeadRow } from "./TableStyle";

type Props = {
  placeData: PlaceDesignData[];
};

const PlaceTable = ({ placeData }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Table>
      <TableHead>
        <TableHeadRow>
          <TableHeadCell>{t("table.header.name")}</TableHeadCell>
          <TableHeadCell>{t("table.header.system_type")}</TableHeadCell>
          <TableHeadCell />
          <TableHeadCell hideColumn>
            {t("table.header.modified_by")}
          </TableHeadCell>
          <TableHeadCell>{t("table.header.last_modified")}</TableHeadCell>
        </TableHeadRow>
      </TableHead>
      {placeData.map(({ place, artifacts }) => (
        <PlaceRow place={place} artifacts={artifacts} key={place.id} />
      ))}
    </Table>
  );
};

export default PlaceTable;
